import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import Home from './components/Home.vue'
import Foo from './components/Foo.vue'
import Bar from './components/Bar.vue'
import Default from './components/404.vue'

const routes = [
    {
        path: '/',
        component: Home
    },
    {
        path: '/foo',
        component: Foo
    },
    {
        path: '/bar',
        component: Bar
    },
    {
        path: '/:w+',
        component: Default
    }
]


const router = createRouter({ 
    history: createWebHistory(),
    routes
})

const app = createApp(App)
app.use(router)
app.mount('#app')